import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SupplementaryequipmentAdminModule } from './supplementaryequipment-admin/supplementaryequipment-admin.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SupplementaryequipmentAdminModule
  ]
})
export class SupplementaryequipmentModule { }
